import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=5e74a22d&scoped=true"
import script from "./ErrorBoundary.vue?vue&type=script&lang=js"
export * from "./ErrorBoundary.vue?vue&type=script&lang=js"
import style0 from "./ErrorBoundary.vue?vue&type=style&index=0&id=5e74a22d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e74a22d",
  null
  
)

export default component.exports